import { Dispatch, SetStateAction, useState } from 'react';

import { WAITING_TIME } from 'coreOld/constants';
import { FormType } from 'partsOld/enums';

const field = {
  [FormType.PRICE]: 'corporatePartPrice',
  [FormType.COST]: 'corporatePartCost',
};

export const useCheckActiveOverlappingUpsert = <T>(
  entity: string,
  selectedItem: T,
  setSelectedItem: Dispatch<SetStateAction<T>>,
  upsertHook,
  removeHook,
  checkActiveOverlappingService
) => {
  const [isActiveItemOverlapping, setIsActiveItemOverlapping] = useState(false);
  const [removedItem, setRemovedItem] = useState<T>();

  const checkActiveItemOverlapping = async (data, skipActiveCheck: boolean) => {
    if (skipActiveCheck) {
      return false;
    }

    const { record } = await checkActiveOverlappingService({
      [field[entity]]: data,
    });

    if (!record) {
      return false;
    }

    setIsActiveItemOverlapping(true);

    return true;
  };

  const onCancel = () => {
    setIsActiveItemOverlapping(false);
  };

  const onSubmitCheck = async (data, skipActiveCheck, onCloseModal) => {
    const isOverlapped = await checkActiveItemOverlapping(data, skipActiveCheck);

    if (!isOverlapped) {
      if (isActiveItemOverlapping) {
        setIsActiveItemOverlapping(false);
      }

      await upsertHook(data);

      setTimeout(() => onCloseModal(), WAITING_TIME);
    }
  };

  const onRemove = async () => {
    await removeHook({ ids: [(selectedItem as any)?.id] });

    setSelectedItem(null);
    setTimeout(() => setRemovedItem(null), WAITING_TIME);
  };

  const onCancelRemove = () => {
    setSelectedItem(removedItem);
    setRemovedItem(null);
  };

  const onCancelBtnClick = () => {
    setRemovedItem(selectedItem);
  };

  return {
    onCancel,
    onSubmitCheck,
    onRemove,
    onCancelRemove,
    onCancelBtnClick,
    removedItem,
    isActiveItemOverlapping,
  };
};
